import React, { SetStateAction } from 'react'
import classes from './TransportTypeSelector.module.sass'

import SelectorItem from './components/selectorItem/SelectorItem'
import {
  equipmentTypes,
  SLOT_ROUTE,
  transportLoadCapacities,
  transportSideTypes,
  transportTypes,
} from '../../../utils/constants'
import { useTransportTypeSelector } from './hooks/useTransportTypeSelector'
import { useLocation } from 'react-router-dom'
import { TransportTypes } from '../../../types/enums'
import { TypesObject } from '../../../types/interfaces'

type Props = {
  topData: TypesObject
  setTopData: React.Dispatch<SetStateAction<TypesObject>>
  multiple?: boolean
}

const TransportTypeSelector = ({ setTopData, topData, multiple }: Props) => {
  const {
    type,
    capacity,
    sideType,
    equipment,
    toggleType,
    toggleEquipment,
    toggleCapacity,
    toggleSideType,
  } = useTransportTypeSelector(setTopData, topData, multiple)
  const location = useLocation()

  return (
    <div className={classes.Container}>
      <div className={classes.SectionLine}>
        <div className={classes.Label}>Тип транспорта</div>
        <div className={classes.Section}>
          {transportTypes
            .filter((el) =>
              location.pathname.includes(SLOT_ROUTE) ? el.id !== TransportTypes.TRUCK : el,
            )
            .map((el) => (
              <SelectorItem key={el.id} el={el} onClick={toggleType} value={type} />
            ))}
        </div>
      </div>
      {transportLoadCapacities.filter((el) =>
        type.some((r) => el.referenceTransportType.includes(r)),
      ).length > 0 && (
        <div className={classes.SectionLine}>
          <div className={classes.Label}>Грузоподъемность</div>
          <div className={classes.Section}>
            {transportLoadCapacities
              .filter((el) => type.some((r) => el.referenceTransportType.includes(r)))
              .map((el) => (
                <SelectorItem key={el.id} el={el} onClick={toggleCapacity} value={capacity} />
              ))}
          </div>
        </div>
      )}
      {transportSideTypes.filter(
        (el) =>
          type.some((r) => el.referenceTransportType.includes(r)) &&
          capacity.some((r) => el.referenceLoadCapacity.includes(r)),
      ).length > 0 && (
        <div className={classes.SectionLine}>
          <div className={classes.Label}>Тип кузова</div>
          <div className={classes.Section}>
            {transportSideTypes
              .filter(
                (el) =>
                  type.some((r) => el.referenceTransportType.includes(r)) &&
                  capacity.some((r) => el.referenceLoadCapacity.includes(r)),
              )
              .map((el) => (
                <SelectorItem key={el.id} el={el} onClick={toggleSideType} value={sideType} />
              ))}
          </div>
        </div>
      )}
      {equipmentTypes.filter(
        (el) =>
          type.some((r) => el.referenceTransportType.includes(r)) &&
          (sideType.some((r) => el.referenceSideType.includes(r)) || !el.referenceSideType.length),
      ).length > 0 && (
        <div className={classes.SectionLine}>
          <div className={classes.Label}>Оборудование</div>
          <div className={classes.Section}>
            {equipmentTypes
              .filter(
                (el) =>
                  type.some((r) => el.referenceTransportType.includes(r)) &&
                  (sideType.some((r) => el.referenceSideType.includes(r)) ||
                    !el.referenceSideType.length),
              )
              .map((el) => (
                <SelectorItem key={el.id} el={el} onClick={toggleEquipment} value={equipment} />
              ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default TransportTypeSelector
